import React from 'react';
import InstructionBlock from 'blocks/instructionblock';
import { FlexContainer } from 'components/flex';
import {
  InstructionContainerCircle,
  InstructionContainerCircleText
} from 'blocks/instructioncontainerblock';
import { PageContent as PageContainer } from 'pages/components';

class InstructionContainerBlock extends React.Component {
  render() {
    const { instructionBlockCollection } = this.props;
    return (
      <PageContainer>
        <FlexContainer
          style={{ flexWrap: 'wrap' }}
          smallAlignContent={'center'}
          smallpadding="1rem">
          {instructionBlockCollection.map((i, index) => (
            <FlexContainer
              column
              width={'50%'}
              key={i.id}
              smallwidth={'90%'}
              border={'0.5rem solid white'}>
              <InstructionContainerCircle>
                <InstructionContainerCircleText>{index + 1}</InstructionContainerCircleText>
              </InstructionContainerCircle>
              <InstructionBlock {...i} />
            </FlexContainer>
          ))}
        </FlexContainer>
      </PageContainer>
    );
  }
}

export default InstructionContainerBlock;
